import { axiosGet } from '../axios/httpRequest';

/**
 * 用户列表
 */
export const getUserListApi = params => {
    return axiosGet('api/user/v1/user', params);
};
